import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyJsdQueuesManageRoute: InvariantJiraRoute = {
	name: 'legacy-jsd-queues-manage',
	path: '/projects/:projectKey/queues/manage',
};
